export const SearchEntityVersionFragment = gql`
  fragment SearchEntityVersionFragment on EntityVersion {
    id
    entity {
      ...SearchEntityFragment
      activeConditions {
        id
        usingLoader
        text
        createdAt
        entity {
          id
          name
          layer {
            id
            type
          }
        }
      }
    }
    intersectingAddresses: intersectingEntities(type: Address) {
      ...SearchEntityFragment
    }
    intersectingParcels: intersectingEntities(type: Parcel) {
      ...SearchEntityFragment
    }
    searchableFields {
      ...EntityFieldFragment
    }
  }
  fragment SearchEntityFragment on Entity {
    id
    name
    uuid
    layer {
      id
      type
    }
  }
`

export const SearchEntityVersionsByLocationFragment = gql`
  fragment SearchEntityVersionsByLocationFragment on EntityVersion {
    id
    entity {
      ...SearchEntityFragment
    }
    coordinates {
      latitude
      longitude
    }
  }
`

export const EntityVersionWithFieldsFragment = gql`
  fragment EntityVersionWithFieldsFragment on EntityVersion {
    id
    fieldsForEntityVersionAndIntersectingEntityVersions {
      ...EntityFieldFragment
    }
    intersectingOtherEntities: intersectingEntities(type: Other) {
      id
      uuid
      name
      layer {
        id
        uuid
        name
      }
      latestVersion {
        id
        fields {
          ...EntityFieldFragment
        }
      }
    }
  }
`
